import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useFocusOnRouteChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const root = document.getElementById("root");
    root?.setAttribute("tabindex", "-1");
    root?.focus();
  }, [pathname]);

  return null;
};

export default useFocusOnRouteChange;
